export enum EditModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
  SHOW = 'show',
}
